// DynamicDisplay.js
import React from 'react';
import DynamicForm from './DynamicForm';

const DynamicDisplay = () => {
  return <DynamicForm />;
};

export default DynamicDisplay;
